import { Component, ViewEncapsulation, Input } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Sprint } from "../../interfaces/sprint";

@Component({
  selector: "app-sprint-card",
  templateUrl: "./sprint-card.component.html",
  styleUrls: ["./sprint-card.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SprintCardComponent {
  env: any = environment;

  @Input() sprint: Sprint;
  @Input() name: string;
  @Input() description: string;
  @Input() isBacklog: boolean;

  constructor() {}

  getItemCount(): number {
    return this.sprint["features"].length;
  }

  getStoryPoints(): number {
    return this.sprint["features"]
      .map((x) => x.effort)
      .filter((x) => x)
      .reduce((x, y) => x + y, 0);
  }

  getEpicCount(): number {
    let epics = this.sprint["features"].map((x) => x.epicId).filter((x) => x);
    return epics.filter((x, i) => epics.indexOf(x) === i).length;
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/sprint-card/sprint-card.component.ts